<template>
  <v-layout>
    <v-snackbar
      v-model="languageLabor.show"
      color="warning"
      top
      :timeout="languageLabor.timeout"
      text-xs-center
    >
      {{ languageLabor.message }}
      <v-icon right dark>error_outline</v-icon>
    </v-snackbar>

    <v-toolbar color="#2d4d85" dark fixed app clipped-right>
      <v-toolbar-title>
        <!-- Skillers -->
        <img
          :src="require('@/assets/img/skillers-logo7.png')"
          height="45px"
          class="mb-1"
        />
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn
          color="white"
          class="hidden-md-and-up"
          flat
          @click="languageLabor.show1 = true"
        >
          Nyelvi labor
        </v-btn>
        <v-btn
          v-if="url === '/registration/landing'"
          flat
          @click="$router.push({ name: 'main' })"
        >
          Főoldal
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-dialog v-model="languageLabor.show1" width="600">
      <v-card>
        <v-card-title class="headline bgBlue dark text-light" primary-title>
          Nyelvi labor

          <v-spacer></v-spacer>

          <!-- <v-btn color="error" fab small @click="languageLabor.show1 = false">
                            <v-icon class="text-light">close</v-icon>
                        </v-btn> -->
        </v-card-title>

        <v-card-text @click="goToEEgytemLogIn">
          <img
            :src="require('@/assets/img/tipp3.png')"
            alt="tipp1"
            class="img-responsive"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  components: {},
  data: () => ({
    drawer: false,
    url: "",
    languageLabor: {
      show: false,
      show1: false,
      message: "Csak előfizetőknek elérhető!",
      timeout: 4000
    }
  }),
  methods: {
    currentUrl() {
      this.$data.url = window.location.pathname;
    },
    goToEEgytemLogIn() {
      this.$data.languageLabor.show = true;
    }
  },
  mounted: () => ({}),
  created: function() {
    // this.$data.loader = true; //Show the loader
    this.currentUrl();
  }
};
</script>
